module.exports = __webpack_public_path__ + "static/media/ic_bank_partial_added.a1cd3fe8.svg";